// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__SaC+h","img":"Banner_img__d10m5","note":"Banner_note__ERPZx","text-right-to-left":"Banner_text-right-to-left__e+8eP"};